import { Menu, MenuButton } from '@headlessui/react';
import { FC, PropsWithChildren } from 'react';
import DropdownMenuItems, {
  DropdownMenuItemProps,
} from '../Dropdown/DropdownMenuItems';
import Button, { ButtonProps } from './Button';

type ButtonDropdownProps = {
  dropdownOptions: DropdownMenuItemProps;
} & ButtonProps;

const ButtonDropdown: FC<PropsWithChildren<ButtonDropdownProps>> = (props) => {
  const { children, dropdownOptions, ...buttonProps } = props;

  return (
    <Menu>
      <MenuButton as={Button} {...buttonProps}>
        {children}
      </MenuButton>

      <DropdownMenuItems {...dropdownOptions} />
    </Menu>
  );
};

export default ButtonDropdown;
